/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  DatePicker,
  InputNumber,
  Input,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import LecturaDeDocumento from 'components/LecturaDeDocumento/LecturaDeDocumento';
import { aplicarDomicilioGeneral } from 'utils/domicilioLeido';
import { onError, onSuccess } from 'utils/handlers';
import { getEstadosGlobales } from 'api/catalogos/index';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import { ModelDireccionGeneral } from 'api/catalogos/DireccionGeneral';
import { getTipoDirecciones } from 'api/catalogos/TiposDireccion';

const modelPermissionName = 'empleadodomiciliosgeneral';
export const DireccionGeneralPermission = {
  permissionModel: modelPermissionName,
  catalogsModels: [],
  tabsModels: [],
};

const DireccionGeneral = ({ permission, IdParent }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposDeDireccion, setTiposDeDireccion] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);

  const {
    cliente,
    nameModel,
    nameModelSingular,
    formatter,
  } = ModelDireccionGeneral;
  const registroName = '';

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    if (!IdParent) {
      setData([]);
      return;
    }
    setLoading(true);
    const _data = await cliente.obtenerListaDeRegistros({ empleado: IdParent });/* (
      {
      nombramiento: IdParent,
    } ); */
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    if (!IdParent) {
      setData([]);
      return undefined;
    }
    const fetchAll = async () => {
      setLoading(true);
      const [
        _data,
        _estados,
        _tiposDeDirecciones,
      ] = await Promise.all([
        cliente.obtenerListaDeRegistros({ empleado: IdParent }),
        getEstadosGlobales(),
        getTipoDirecciones(),
      ]);
      if (mounted) {
        setTiposDeDireccion(_tiposDeDirecciones);
        setData(formatReceived(_data));
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, [IdParent]);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _regristo = await cliente.obtenerUnRegistro(match.id);

    setTimeout(() => {
      if (_regristo) {
        const formValues = formatter.formatRecordForRead(_regristo);
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_regristo?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const valuesForm = form.getFieldsValue();
      const [key] = selectedRowKeys;

      const values = formatter.formatRecordForSend(valuesForm);
      const saved = await (key
        ? cliente.actualizarRegistro(key, values)
        : cliente.crearRegistro(values)
      );
      if (saved) {
        if (_continue) {
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
        }
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await cliente.borrarRegistro(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = formatter.formatRecordForRead(record);

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, `No se puede autorizar ${nameModelSingular} ya autorizado`);
        return;
      }
      const saved = await cliente.autorizarRegistro(key);
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const nameTipoDeDireccion = 'tipo_de_direccion';
  const nameVialidad = 'vialidad';
  const nameNo_exterior = 'no_exterior';
  const nameNo_interior = 'no_interior';
  const nameColonia = 'colonia';
  const nameEntre_la_calle = 'entre_la_calle';
  const nameY_la_calle = 'y_la_calle';
  const nameCodigo_postal = 'codigo_postal';
  const nameMunicipio = 'municipio';
  const nameEstado = 'estado';
  const nameDescripcion_de_la_ubicacion = 'descripcion_de_la_ubicacion';
  const nameDescripcion_conjunta = 'descripcion_conjunta';

  const columns = [
    {
      titleText: 'Tipo de Dirección',
      dataIndex: nameTipoDeDireccion,
      key: nameTipoDeDireccion,
      width: 200,
      render: (_, record) => record?.[nameTipoDeDireccion]?.descripcion || '',
    },
    {
      titleText: 'Vialidad',
      dataIndex: nameVialidad,
      key: nameVialidad,
      width: 200,
    },
    {
      titleText: 'No. Exterior',
      dataIndex: nameNo_exterior,
      key: nameNo_exterior,
      width: 200,
    },
    {
      titleText: 'Número Interior',
      dataIndex: nameNo_interior,
      key: nameNo_interior,
      width: 200,
    },
    {
      titleText: 'Colonia',
      dataIndex: nameColonia,
      key: nameColonia,
      width: 200,
    },
    {
      titleText: 'Entre la Calle',
      dataIndex: nameEntre_la_calle,
      key: nameEntre_la_calle,
      width: 200,
    },
    {
      titleText: 'Y la Calle',
      dataIndex: nameY_la_calle,
      key: nameY_la_calle,
      width: 200,
    },
    {
      titleText: 'Código Postal',
      dataIndex: nameCodigo_postal,
      key: nameCodigo_postal,
      width: 200,
    },
    {
      titleText: 'Municipio',
      dataIndex: nameMunicipio,
      key: nameMunicipio,
      width: 200,
    },
    {
      titleText: 'Estado',
      dataIndex: nameEstado,
      key: nameEstado,
      width: 200,
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
      render: (vigencia) => (vigencia ? new Date(vigencia).toLocaleDateString() : ''),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (id) => estados?.find((_Record) => _Record?.id === id)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'empleadodomiciliosgeneral', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            width="80%"
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} ${nameModel} `}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="general"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
                empleado: IdParent,
              }}
            >
              <Row gutter={10}>
                <Col span={24}>
                  <Form.Item>
                    <LecturaDeDocumento
                      tipo="DOMICILIO"
                      texto="Leer Domicilio de INE, Constancia o Comprobante"
                      disabled={disableFields}
                      onDatos={(domicilio) => aplicarDomicilioGeneral({ domicilio, form })}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameTipoDeDireccion}
                    rules={rules.required}
                    label="Tipo de Dirección"
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={tiposDeDireccion}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameVialidad}
                    label="Vialidad"
                    hasFeedback
                  >
                    <Input
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameNo_exterior}
                    label="No. Exterior"
                    hasFeedback
                  >
                    <Input
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameNo_interior}
                    label="No. Interior"
                    hasFeedback
                  >
                    <Input
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameColonia}
                    label="Colonia"
                    hasFeedback
                  >
                    <Input
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameEntre_la_calle}
                    label="Entre la Calle"
                    hasFeedback
                  >
                    <Input
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameY_la_calle}
                    label="Y la Calle"
                    hasFeedback
                  >
                    <Input
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameCodigo_postal}
                    label="Código Postal"
                    hasFeedback
                  >
                    <InputNumber
                      minLength={5}
                      maxLength={5}
                      disabled={disableFields}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameMunicipio}
                    label="Municipio"
                    hasFeedback
                  >
                    <Input
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name={nameEstado}
                    label="Estado"
                    hasFeedback
                  >
                    <Input
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="vigencia_final"
                    label="Vigencia Final"
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="YYYY-MM-DD"
                      placeholder=""
                      disabled={isAdding || selectedData?.estados_globales === ESTATUS_INACTIVO}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estados}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    name={nameDescripcion_de_la_ubicacion}
                    label="Descripción de la Ubicación"
                    hasFeedback
                  >
                    <Input.TextArea
                      autoSize={{ minRows: 2, maxRows: 3 }}
                      maxLength={250}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    name={nameDescripcion_conjunta}
                    label="Dirección Conjunta"
                    hasFeedback
                  >
                    <Input.TextArea
                      autoSize={{ minRows: 2, maxRows: 3 }}
                      maxLength={250}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="empleado"
                    label="Parent Id"
                    hasFeedback
                    hidden
                  >
                    <Input
                      hidden
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`${nameModelSingular} ${registroName}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar ${nameModelSingular} ${registroName}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar ${nameModelSingular} ${registroName}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default DireccionGeneral;
